import styles from 'styles/search/SeoHeadings.module.css'

export default function SearchSeoHeadings (props) {
    const { h1, h2, headText } = resolveHeadings(props)

    if (!h1 && !h2 && !headText) return null
    return (
        <div className="container">
            { h1 && <h1 className={styles.h1}>{h1}</h1> }
            { h2 && <h2 className={styles.h2}>{h2}</h2> }
            { headText && <div className={styles.span} dangerouslySetInnerHTML={{ __html: headText }} /> }
        </div>
    )
}

function resolveHeadings ({ seo, defaultValues }) {
    return {
        h1: seo.h1 || defaultValues.h1,
        h2: seo.h2 || defaultValues.h2,
        headText: seo.headText || '',
    }
}